export var Services = {
    Search: {
        default: 'https://search.collegeboard.org/'
    }
};
export default Services;
